import React, { Fragment, useContext, useEffect, useState } from "react";
import OrderDetail from "../../../container/OrderManagementFlow/OrderDetail";
import OrderReturnDetail from "../../../container/OrderManagementFlow/OrderReturnDetail";
import { AppMainContainer, AppSubContainer } from "../../../../Libraries";
import { LanguageContext } from "../../../../context/LanguageContext";
import useGetUpdateOrder from "../../../../hooks/useGetUpdateOrder";
import useOrderLines from "../../../../hooks/useOrderLines";
import BusinessLoader from "../../../common/BusinessLoader";
import fourOFour from "../../../../assets/images/404.webp";
import { setCurrentScreen } from "firebase/analytics";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import {
  AppNonIdeal
} from "../../../common";
import { GET_ORDER_DETAILS_BY_ID, GET_RETURN_ORDER_DETAILS_BY_ID } from "../../../../apis/configuration";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const OrderManagementDetail = () => {
  const params = useParams();
  const location = useLocation();
  const orderId = params?.id;
  let isSeller = localStorage.getItem("is_marketplace_seller");
  const navigate = useNavigate();
  const {
    handleReturnOrderList,
    handleOrderList,
    orderListParams,
    orderList,
    returnList
  } = useOrderLines() || {};
  const { handleOrder, handleBulkOrder, setOrder, order } =
    useGetUpdateOrder() || {};
  const { rejectReasons } = orderListParams || {};
  const { order_detail } = order || [];

  const [I18n] = useContext(LanguageContext);
  const [updateLoad, setUpdateLoad] = useState(false);
  const [getLoad, setGetLoad] = useState(true);
  const isReturnOrder = location?.pathname.includes('/SaddarOrders/returns/');
  useEffect(() => {
    handleOrder(isReturnOrder ? GET_RETURN_ORDER_DETAILS_BY_ID : GET_ORDER_DETAILS_BY_ID, { id: orderId }, true).finally(() => setGetLoad(false));
    if (isSeller) {
      if (!isReturnOrder && !orderList?.length) handleOrderList();
      else if (isReturnOrder && !returnList?.length) handleReturnOrderList();
    }
  }, [isReturnOrder])

  useEffect(() => {
    setCurrentScreen(analytics, "OrderManagement_screen");

  }, []);


  /**
   * Receive endpoint, params for for accept, reject, shipped, dispatch date and edit order.
   * Referesh param for updating the detail view of order
   * @returns perform action and return updtaed list
   */
  const handleOrderStatus = (endpoint, params, refresh, multiple = false) => {
    setUpdateLoad(true);
    setGetLoad(true);
    return new Promise(async (resolve, reject) => {
      try {
        multiple
          ? await handleBulkOrder(endpoint, params, refresh)
          : await handleOrder(endpoint, params, refresh);
        !isReturnOrder ? await handleOrderList() : handleReturnOrderList();
        resolve();
        setUpdateLoad(false);
        setGetLoad(false);
      } catch (err) {
        reject(err);
        setUpdateLoad(false);
        setGetLoad(false);
      }
    });
  };


  return isSeller ? (
    <Fragment>
      <>
        {order_detail?.length ? (
          isReturnOrder ?
            <OrderReturnDetail
              navigate={navigate}
              data={{
                handleOrderStatus,
                updateLoad,
                order,
                I18n,
              }}
            /> :
            <OrderDetail
              navigate={navigate}
              data={{
                handleOrderStatus,
                rejectReasons,
                updateLoad,
                order,
                I18n,
              }}
            />
        ) : null}
      </>
      <BusinessLoader loadBusiness={getLoad} />
    </Fragment>
  ) : (
    <AppMainContainer>
      <AppSubContainer>
        <AppNonIdeal
          data={{
            title: I18n.page_not_found,
            subtitle: I18n.we_re_sorry_the_page_you_requested,
            image: fourOFour,
            I18n,
          }}
        />
      </AppSubContainer>
    </AppMainContainer>
  );
};


export default OrderManagementDetail;
